function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'mkui-fd';

var HelpLink = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HelpLink, _React$PureComponent);

  function HelpLink() {
    _classCallCheck(this, HelpLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(HelpLink).apply(this, arguments));
  }

  _createClass(HelpLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          children = _this$props.children,
          href = _this$props.href,
          style = _this$props.style;
      return React.createElement("a", {
        href: href,
        target: "_blank",
        className: prefixCls,
        style: style
      }, React.createElement(Icon, {
        type: "info-circle",
        theme: "filled",
        className: "".concat(prefixCls, "-icon")
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-text")
      }, children ? children : '使用说明'));
    }
  }]);

  return HelpLink;
}(React.PureComponent);

_defineProperty(HelpLink, "propTypes", {
  prefixCls: PropTypes.string,
  href: PropTypes.string,
  style: PropTypes.object
});

_defineProperty(HelpLink, "defaultProps", {
  prefixCls: 'mkui-help-link'
});

export { HelpLink as default };
//# sourceMappingURL=HelpLink.js.map
